import { Communicator } from "./databin$"
import { CoordinatorService } from "./coordinator.service"
import { BehaviorSubject, Subject } from "rxjs"
import { XItem } from "./x-item"

export class ProjectCommunicator implements Communicator{
    // buttonCommunicator$ = new Subject()
    tag = "project"
    update$ = new Subject<void>()
    itmLs: Object[] = []

    message$ = new BehaviorSubject<string>("")
    xitemLs$ = new BehaviorSubject<XItem[]>([])

    constructor(public coords: CoordinatorService) {

    }

    get connection() {
        return this.coords.databin$.editedConnection$.getValue()!
    }

    // async confirm() {
    //     this.connection.readParserList(this.itmLs)
    //     await this.connection.finalize()
    //     this.update$.next()
    // }
}


